import { createContext } from "react";
import React from "react";

const NoteContext = createContext();

export default NoteContext;
